export function processSize(size) {
    return !/^\d+$/.test(size) ? size : "".concat(size, "px");
}
export function noop() { }
//# sourceMappingURL=utils.js.map